"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var BasicIcon_1 = __importDefault(require("../../../../../../components/common/BasicIcon"));
var Button_1 = __importDefault(require("../../../../../../components/Button"));
var Icon_1 = __importDefault(require("../../../../../../components/Icon"));
var ApartmentForm_1 = __importDefault(require("./ApartmentForm"));
var postSlice_1 = require("../../../../../../features/post/postSlice");
var globalSlice_1 = require("../../../../../../features/global/globalSlice");
var PostTabsContext_1 = require("../../../../../../contexts/PostTabsContext");
var schemaSlice_1 = require("../../../../../../features/post/schemaSlice");
var validateEntityRequiredFields_1 = require("../../../../../../helpers/validateEntityRequiredFields");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var ApartmentsCard = function (_a) {
    var _b, _c;
    var step = _a.step, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded, handleSubmitApartmentForm = _a.handleSubmitApartmentForm, isApartmentFormSubmitted = _a.isApartmentFormSubmitted, setCollapsedApartmentId = _a.setCollapsedApartmentId, collapsedApartmentId = _a.collapsedApartmentId, setIsApartmentFormSubmitted = _a.setIsApartmentFormSubmitted;
    var t = react_i18next_1.useTranslation('common').t;
    var setIsFormErrors = react_1.useContext(PostTabsContext_1.PostTabsContext).setIsFormErrors;
    var dispatch = react_redux_1.useDispatch();
    var id = post.id;
    var order = step.order, name = step.name, config = step.config;
    var apartmentDefaults = postSlice_1.composeSingleSectionInitialValues(step);
    var tabRef = react_1.useRef(null);
    var handleTabPositionChange = react_1.useContext(PostTabsContext_1.PostTabsContext).handleTabPositionChange;
    var currentPropertyData = react_redux_1.useSelector(schemaSlice_1.selectCurrentPropertyType);
    var apartmentErrorsKeys = react_redux_1.useSelector(postSlice_1.selectUpdatePostFailureErrors);
    var canRemove = react_1.useMemo(function () {
        return formikProps.values.apartment_info.length > 1;
    }, [formikProps.values.apartment_info.length]);
    react_1.useEffect(function () {
        if (tabRef.current && formikProps.values[name].length) {
            handleTabPositionChange(name, tabRef.current.offsetTop, tabRef.current.offsetTop + tabRef.current.offsetHeight);
        }
    }, [isLoaded, (_b = tabRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop, (_c = tabRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight]);
    var uploadMedia = function (apartmentId, files) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.uploadApartmentMedia(id, apartmentId, files))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_1.response.data.errors[key]
                            ? t('ERRORS.' + e_1.response.data.errors[key][0])
                            : t('ERRORS.IMAGE_UPLOAD_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var uploadEntityPlanMedia = function (apartmentId, file, type) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.uploadEntityPlanMediaById(id, apartmentId, file, type))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_2 = _a.sent();
                    key = Object.keys(e_2.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_2.response.data.errors[key]
                            ? t('ERRORS.' + e_2.response.data.errors[key][0])
                            : t('ERRORS.IMAGE_UPLOAD_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeEntityPlanMedia = function (apartmentId, mediaId, type) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.removeEntityPlanMediaById(id, apartmentId, mediaId, type))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_3 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REMOVE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeEntityMedia = function (apartmentId, mediaId) { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.removeEntityMediaByID(id, apartmentId, mediaId))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_4 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REMOVE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reorderMedia = function (apartmentId, from, to) { return __awaiter(void 0, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.reorderApartmentMedia(id, apartmentId, from, to))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_5 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REORDER_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var newApartment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasErrors, apt, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    hasErrors = validateEntityRequiredFields_1.validateEntityRequiredFields(formikProps);
                    hasErrors && setIsFormErrors(true);
                    if (!!hasErrors) return [3 /*break*/, 2];
                    dispatch(postSlice_1.clearPostFailureErrors());
                    return [4 /*yield*/, dispatch(postSlice_1.addEmptyApartment(id))];
                case 1:
                    apt = _a.sent();
                    setIsApartmentFormSubmitted(false);
                    setCollapsedApartmentId('');
                    formikProps.setFieldValue(name, __spreadArray(__spreadArray([], formikProps.values[name]), [
                        __assign(__assign({}, apartmentDefaults[0]), apt),
                    ]));
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_6 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.NEW_APARTMENT_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var duplicateApt = function (apartmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var entity_id, apt, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(postSlice_1.clearPostFailureErrors());
                    return [4 /*yield*/, dispatch(postSlice_1.duplicateApartment(id, apartmentId))];
                case 1:
                    entity_id = (_a.sent()).entity_id;
                    setIsApartmentFormSubmitted(false);
                    setCollapsedApartmentId('');
                    apt = formikProps.values[name].find(function (_a) {
                        var entity_id = _a.entity_id;
                        return entity_id === apartmentId;
                    });
                    formikProps.setFieldValue(name, __spreadArray(__spreadArray([], formikProps.values[name]), [
                        __assign(__assign({}, apt), { entity_id: entity_id }),
                    ]));
                    return [3 /*break*/, 3];
                case 2:
                    e_7 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.DUPLICATE_APARTMENT_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeApt = function (apartmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(postSlice_1.clearPostFailureErrors());
                    return [4 /*yield*/, dispatch(postSlice_1.removeApartment(id, apartmentId))];
                case 1:
                    _a.sent();
                    formikProps.setFieldValue(name, formikProps.values[name].filter(function (apt) { return apt.entity_id !== apartmentId; }));
                    return [3 /*break*/, 3];
                case 2:
                    e_8 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.REMOVE_APARTMENT_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { ref: tabRef },
        react_1.default.createElement("div", { className: classnames_1.default('element form-section', styles_module_scss_1.default.card), key: order },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_header },
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.header_title },
                        react_1.default.createElement(BasicIcon_1.default, { iconClass: step.icon }),
                        react_1.default.createElement("h3", null, t(config.displayCondition.headerTitles[currentPropertyData]))),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.header_actions },
                        react_1.default.createElement(Button_1.default, { variant: "text", className: styles_module_scss_1.default.header_action, onClick: function (e) {
                                e.preventDefault();
                                newApartment();
                            } },
                            react_1.default.createElement(Icon_1.default, { semanticName: "plus circle" }),
                            react_1.default.createElement("span", null, t('POST_SCREEN.ADD_NEW_SECTION.' +
                                currentPropertyData.toUpperCase()))))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: classnames_1.default('ui styled accordion', styles_module_scss_1.default.card_content) }, formikProps.values[name].map(function (apartment, index) { return (react_1.default.createElement(ApartmentForm_1.default, { hasApartmentsErrors: apartmentErrorsKeys.includes(String(index)), apartmentId: apartment.entity_id, key: index, index: index, step: step, formikProps: formikProps, uploadMedia: uploadMedia, uploadEntityPlanMedia: uploadEntityPlanMedia, removeEntityPlanMedia: removeEntityPlanMedia, removeEntityMedia: removeEntityMedia, reorderMedia: reorderMedia, duplicateApartment: duplicateApt, removeApartment: removeApt, canRemove: canRemove, handleSubmitApartmentForm: handleSubmitApartmentForm, isApartmentFormSubmitted: isApartmentFormSubmitted, setCollapsedApartmentId: setCollapsedApartmentId, collapsedApartmentId: collapsedApartmentId })); })))))));
};
exports.default = ApartmentsCard;
